import * as React from "react";
import type { ReactNode } from "react";
import { Button, CandyTooltip as Tooltip } from "react-ui";
import { XIcon16Light } from "@skbkontur/icons/XIcon16Light";

import { MetricValue, useMetrics } from "../../../../Internals/Metrics/MetricsProviderContext";
import { VIEW_FILE_TOOLTIP, VIEW_FILE_TOOLTIP_CANCEL, VIEW_FILE_TOOLTIP_REMOVE } from "../../../../metricsAction";

import {
    RemoveButtonContainer,
    ButtonDelimiter,
    TooltipMessageContent,
    TooltipText,
} from "./RemoveAttachmentButton.styles";

interface RemoveAttachmentButtonProps {
    onRemove: () => void;
    metricsContext: { [key: string]: MetricValue };
    customElement?: ReactNode;
}

export function RemoveAttachmentButton(props: RemoveAttachmentButtonProps): JSX.Element {
    const track = useMetrics();
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

    const tooltipTrigger = isTooltipOpen ? "opened" : "closed";

    const removeFile = async (): Promise<void> => {
        track(VIEW_FILE_TOOLTIP_REMOVE, props.metricsContext);
        setIsTooltipOpen(false);
        props.onRemove();
    };

    const handlerOnClickCloseTooltip = (): void => {
        track(VIEW_FILE_TOOLTIP_CANCEL, props.metricsContext);
        setIsTooltipOpen(false);
    };

    const handlerOnClickCloseTooltipButton = (e: React.MouseEvent): void => {
        track(VIEW_FILE_TOOLTIP_CANCEL, props.metricsContext);
        e.stopPropagation();
        setIsTooltipOpen(false);
    };

    const renderConfirmationTooltipContent = (): JSX.Element => {
        track(VIEW_FILE_TOOLTIP, props.metricsContext);
        return (
            <TooltipMessageContent>
                <TooltipText>Вы уверены, что хотите удалить документ?</TooltipText>
                <Button data-tid="RemoveButton" size="medium" use="danger" onClick={removeFile}>
                    Удалить
                </Button>
                <ButtonDelimiter />
                <Button size="medium" onClick={handlerOnClickCloseTooltipButton}>
                    Отменить
                </Button>
            </TooltipMessageContent>
        );
    };

    return (
        <RemoveButtonContainer
            data-tid="RemoveArea"
            onClick={() => setIsTooltipOpen(true)}
            confirmationOpened={isTooltipOpen}>
            <Tooltip
                data-tid="RemoveTooltip"
                pos="right middle"
                render={renderConfirmationTooltipContent}
                trigger={tooltipTrigger}
                onCloseRequest={handlerOnClickCloseTooltip}>
                {props.customElement ?? <XIcon16Light />}
            </Tooltip>
        </RemoveButtonContainer>
    );
}
